import { render, staticRenderFns } from "./BoardV2Icon.vue?vue&type=template&id=b97aef9e&scoped=true"
import script from "./BoardV2Icon.vue?vue&type=script&lang=js"
export * from "./BoardV2Icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97aef9e",
  null
  
)

export default component.exports